import { Account, Ed25519PrivateKey } from "@aptos-labs/ts-sdk";

export const createAccountFromPrivateKey = (privateKey: string): Account => {
  const privateKeyEd25519 = new Ed25519PrivateKey(privateKey);
  return Account.fromPrivateKey({ privateKey: privateKeyEd25519 });
};

export const normalizeAddress = (addr: string): string => {
  const hex = addr.startsWith("0x") ? addr.slice(2) : addr;
  return `0x${hex.padStart(64, "0")}`;
};
